import React, { useEffect, useMemo, useState } from 'react'
import classes from "./PricingNewpayment.module.css";
import promix from "../../Assets/Promix.svg"
import deletes from "../../Assets/delete.svg"
import credtcrd from "../../Assets/Credit Card.png"
import wallet from "../../Assets/wallet-03.png"
import card from "../../Assets/credit-card-01.png"
import lock from "../../Assets/lock.png"
import arrowleft from "../../Assets/arrow-left.png"
import marked from "../../Assets/tick.png"
import star from "../../Assets/star.svg"
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from "../../Components/API/Api";
import api, { withCompanyId } from "../../Components/API/Api";
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';

const PricingNewPayment = () => {
    const [showPaystackModal, setShowPaystackModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showAcctModal, setShowAcctModal] = useState(false);
    const handleShowSuccessModal = () => setShowSuccessModal(true);
    const handleShowAcctModal = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };
    const handleCloseAcctModal = () => setShowAcctModal(false);
    const handleCloseSuccessModal = () => setShowSuccessModal(false);
    const [successSummary, setSuccessSummary] = useState(null);
    const [showDeclinedModal, setShowDeclinedModal] = useState(false);
    const [showAccountDetailsModal, setShowAccountDetailsModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("paystack");
    const [savingAccountsLoading, setSavingAccountsLoading] = useState(false);
    const [isRestoringSession, setIsRestoringSession] = useState(false);
    // Dummy wallet account details
    const [accountDetails, setAccountDetails] = useState({ accountName: 'Demo User', accountNumber: '9876543210', bank: 'DemoBank' });
    // Dummy wallet balance (set to 0 for insufficient funds test)
    const [walletBalance, setWalletBalance] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const [rows, setRows] = useState([
        { accountName: "", accountCode: "", description: "", debit: "", credit: "", showDropdown: false }
    ]);
    const [accountTypes, setAccountTypes] = useState([]);
    const [loadingTypes, setLoadingTypes] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const { login, setActiveCompany } = useUser();
    const selectedPlan = location.state?.selectedPlan;
    const locationCompanyId = location.state?.company_id;
    const locationIndustryId = location.state?.industryId;
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const formatMonthlyPrice = (plan) => {
        if (!plan || plan.monthly == null) return "₦0";
        const value = parseFloat(plan.monthly);
        if (Number.isNaN(value)) return "₦0";
        return `₦${value.toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

      const removeRow = (index) => {
    setRows(prev => prev.length === 1 ? prev : prev.filter((_, i) => i !== index));
  };

//     const addLine = () => {
//     setRows(prev => [
//       ...prev,
//       { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false },
//     ]);
//   };

const addLine = () => {
  setRows(prev => [
    ...prev,
    {
      accountId: "",
      accountDisplay: "",
      description: "",
      debit: "",
      credit: "",
      showDropdown: false,
      isPrefilled: false, // 👈 user-added rows
    },
  ]);
};  




  const handleChange = (index, field, value) => {
    setRows(prev => {
      const newRows = [...prev];
      const row = { ...newRows[index] };
      if (field === "debit") {
        row.debit = value;
        if (parseFloat(value) > 0) row.credit = "0";
      } else if (field === "credit") {
        row.credit = value;
        if (parseFloat(value) > 0) row.debit = "0";
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else if (field === "showDropdown") {
        row.showDropdown = value;
      } else {
        row[field] = value;
      }
      newRows[index] = row;
      return newRows;
    });
  };

    const planName = selectedPlan?.name || "Professional";
    const planDescription = selectedPlan?.use || "For growing businesses and small teams";
    const planAmount = selectedPlan ? formatMonthlyPrice(selectedPlan) : "₦25,000";
    const planPrivileges = selectedPlan?.privileges || [
        "5 Users",
        "Advanced Reports",
        "Multi-currency",
        "API Access",
        "Priority Support",
        "Custom Integrations",
        "Automated Workflows",
    ];

      // Fetch accounts
      useEffect(() => {
        const fetchAccounts = async () => {
          const token = localStorage.getItem("authToken");
          if (!token) return;
          setAccountsLoading(true);
          try {
            const res = await api.get('/v1/account/company-accounts');
            let raw = res?.data?.data ?? res?.data ?? [];
            if (Array.isArray(raw.data)) raw = raw.data;
            setAccounts(Array.isArray(raw) ? raw : []);
          } catch (err) {
            console.error("Error fetching accounts:", err);
            setAccounts([]);
          } finally {
            setAccountsLoading(false);
          }
        };
    
        if (showAcctModal) fetchAccounts();
      }, [showAcctModal]);

          const token = localStorage.getItem("authToken");

          useEffect(() => {
              const fetchAccountTypes = async () => {
                  try {
                      setLoadingTypes(true);
                      const resp = await api.get('/v1/get-sub-categories');
                      const raw = resp?.data?.data ?? resp?.data ?? [];
                      const list = Array.isArray(raw) ? raw : [];
                      setAccountTypes(list);
                  } catch (e) {
                      console.error('Failed to load account types', e?.response?.data || e?.message);
                      setAccountTypes([]);
                  } finally {
                      setLoadingTypes(false);
                  }
              };
      
              if (showAcctModal) {
                  fetchAccountTypes();
              }
          }, [showAcctModal, token]);
      
    
      // Populate rows with accounts
    //   useEffect(() => {
    //     if (showAcctModal && accounts.length > 0) {
    //       setRows(accounts.map(acc => ({
    //         accountId: acc.id,
    //         accountName: acc.gl_name ?? acc.name ?? "",
    //         accountCode: acc.gl_code ?? acc.code ?? "",
    //         description: "",
    //         debit: "",
    //         credit: "",
    //         showDropdown: false
    //       })));
    //     }
    //   }, [showAcctModal, accounts]);

        useEffect(() => {
        if (showAcctModal && accounts.length > 0) {
            setRows(
            accounts.map(acc => ({
                accountId: acc.id,
                accountName: acc.gl_name ?? acc.name ?? "",
                accountCode: acc.gl_code ?? acc.code ?? "",
                description: "",
                debit: "",
                credit: "",
                showDropdown: false,
                isPrefilled: true, // 👈 add this
            }))
            );
        }
        }, [showAcctModal, accounts]);

    
        const saveNewAccounts = async () => {
        try {
            setSavingAccountsLoading(true);

            // get company_id
            const companyId =
            localStorage.getItem("company_id") ||
            localStorage.getItem("activeCompanyId");

            if (!companyId) {
            Swal.fire("Error", "Company ID not found", "error");
            return;
            }

            // only newly added rows
            const newRows = rows.filter((row) => !row.isPrefilled);

            if (newRows.length === 0) {
            Swal.fire("Info", "No new accounts to save", "info");
            return;
            }

            // validate rows
            const invalidRow = newRows.find(
            (row) => !row.accountName || !row.accountCode
            );

            if (invalidRow) {
            Swal.fire(
                "Validation Error",
                "All new rows must have account name and account type",
                "warning"
            );
            return;
            }

            // format payload
            const payload = {
            account_type: newRows.map((row) => row.accountCode),
            account_name: newRows.map((row) => row.accountName),
            company_id: companyId,
            };

            console.log("Payload:", payload);

            const response = await api.post(
            "/v1/create-account-array",
            payload
            );

            if (
            response?.data?.status === true ||
            response?.data?.success === true
            ) {
            Swal.fire(
                "Success",
                "Accounts created successfully",
                "success"
            );

            // navigate to dashboard
            navigate("/dashboard");

            } else {
            Swal.fire(
                "Error",
                response?.data?.message || "Failed to save accounts",
                "error"
            );
            }
        } catch (error) {
            console.error(error);

            Swal.fire(
            "Error",
            error?.response?.data?.message ||
                "Something went wrong",
            "error"
            );
        } finally {
            setSavingAccountsLoading(false);
        }
        };
    

    // Ensure page is scrolled to top whenever this route is navigated to
    useEffect(() => {
        try {
            window.scrollTo(0, 0);
        } catch {
            // ignore if environment doesn't support window scrolling
        }
    }, [location.pathname]);

    // If Paystack redirects back after checkout, show the appropriate modal.
    useEffect(() => {
        const handleRedirectResult = async () => {
            // Merge search params and hash params (some gateways use hash fragments)
            const combined = new URLSearchParams(location.search || "");
            if (location.hash) {
                const hashString = location.hash.replace(/^#/, "");
                const hashParams = new URLSearchParams(hashString);
                for (const [k, v] of hashParams.entries()) {
                    if (!combined.has(k)) combined.set(k, v);
                }
            }

            const status = (combined.get("status") || combined.get("payment_status") || "").toLowerCase();
            const successFlag = (combined.get("success") || combined.get("paid") || "").toLowerCase();
            const failedFlag = (combined.get("failed") || combined.get("cancelled") || "").toLowerCase();

            const isSuccessFromRedirect =
                status === "success" ||
                status === "successful" ||
                successFlag === "true" ||
                successFlag === "1" ||
                successFlag === "yes";

            const isFailedFromRedirect =
                status === "failed" ||
                status === "failure" ||
                status === "cancelled" ||
                status === "canceled" ||
                failedFlag === "true" ||
                failedFlag === "1" ||
                failedFlag === "yes";

            const referenceParam = combined.get("reference") || combined.get("trxref") || combined.get("tx_ref") || "";
            const treatReferenceAsSuccess = referenceParam && !isFailedFromRedirect;

            // Debug helpers to help during testing
            try {
                console.debug("Payment redirect params:", Object.fromEntries(combined.entries()));
            } catch {}

            if (isSuccessFromRedirect || treatReferenceAsSuccess) {
                console.log("Token after redirect:", localStorage.getItem("token"));
                let foundSummary = null;
                try {
                    const raw = localStorage.getItem("pendingPaymentSummary");
                    if (raw) foundSummary = JSON.parse(raw);
                } catch (err) {
                    console.debug("Failed to read pendingPaymentSummary:", err);
                } finally {
                    localStorage.removeItem("pendingPaymentSummary");
                }

                const planFromQuery = combined.get('plan') || combined.get('plan_name') || '';
                const amountFromQuery = combined.get('amount') || combined.get('amountPaid') || combined.get('amount_paid') || '';

                const formatAmount = (val) => {
                    if (!val) return planAmount;
                    const n = Number(String(val).replace(/[^0-9.-]+/g, ''));
                    if (Number.isFinite(n)) {
                        const naira = n / 100; // Convert from kobo to naira
                        return `₦${naira.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    }
                    return String(val);
                };

                if (!foundSummary) {
                    foundSummary = {
                        plan: planFromQuery || selectedPlan?.name || planName,
                        amountPaid: formatAmount(amountFromQuery) || planAmount,
                        billing: combined.get('billing') || 'Monthly',
                    };
                } else {
                    if (planFromQuery) foundSummary.plan = planFromQuery;
                    if (amountFromQuery) foundSummary.amountPaid = formatAmount(amountFromQuery);
                    if (combined.get('billing')) foundSummary.billing = combined.get('billing');
                }

                setSuccessSummary(foundSummary);

                try {
                    localStorage.setItem("hasPaidPlan", "true");
                } catch {}

                setIsRestoringSession(true);
                try {
                    await autoLoginUser({ redirectToDashboard: false });
                } finally {
                    setIsRestoringSession(false);
                }
                handleShowSuccessModal();
            } else if (isFailedFromRedirect) {
                localStorage.removeItem("pendingPaymentSummary");
                setShowDeclinedModal(true);
            }
        };

        void handleRedirectResult();
    }, [location.search, location.hash]);

    // Load user's auto-generated wallet account details from localStorage
    // Dummy data: skip loading from localStorage for now
    // useEffect(() => {
    //     ...existing code...
    // }, []);

    // Function to auto-login user after successful payment
    const autoLoginUser = async ({ redirectToDashboard } = { redirectToDashboard: false }) => {
        try {
            const userEmail = localStorage.getItem("userEmail");
            const userPassword = localStorage.getItem("userPassword");

            if (!userEmail || !userPassword) {
                console.warn("User credentials not found in localStorage for auto-login");
                return;
            }

            const response = await api.post(`/v1/login`, {
                email: userEmail,
                password: userPassword,
            });

            if (response.data?.status === true || response.data?.success === true) {
                const token = response.data?.data?.token || response.data?.token;
                const userData = response.data?.data?.user || response.data?.user;

                if (token && userData) {
                    // Use the login function from UserContext
                    login(userData, token);

                    // Fetch companies and pick one so dashboard requests have company_id
                    try {
                        // Preserve industry data before clearing company data
                        const savedIndustryId = localStorage.getItem('industryId') || localStorage.getItem('selectedIndustryId');
                        const savedCompanyInfo = localStorage.getItem('companyInfo');

                        // Clear any previous company data to avoid conflicts
                        // localStorage.removeItem('company_id');
                        // localStorage.removeItem('activeCompanyId');
                        // localStorage.removeItem('companyInfo');
                        // localStorage.removeItem('companies');

                        const compRes = await api.get(`/v1/companies/get-info`);
                        const list = Array.isArray(compRes?.data?.data)
                            ? compRes.data.data
                            : (compRes?.data?.data ? [compRes.data.data] : []);
                        try { localStorage.setItem('companies', JSON.stringify(list)); } catch {}

                        const first = list?.[0] || null;
                        const cid = first?.company_id || first?.id || first?.companyId || null;
                        const industryIdFromResponse = first?.industry_id || first?.industry || savedIndustryId;

                        if (cid && typeof setActiveCompany === 'function') {
                            setActiveCompany(String(cid), first);
                        } else if (cid) {
                            try { localStorage.setItem('company_id', String(cid)); } catch {}
                            try { localStorage.setItem('activeCompanyId', String(cid)); } catch {}
                            try { localStorage.setItem('companyInfo', JSON.stringify(first)); } catch {}
                        }

                        // Restore or set industry_id from response or saved value
                        if (industryIdFromResponse) {
                            try { localStorage.setItem('industryId', String(industryIdFromResponse)); } catch {}
                            try { localStorage.setItem('selectedIndustryId', String(industryIdFromResponse)); } catch {}
                            console.log("Industry ID restored/set:", industryIdFromResponse);
                        } else if (savedIndustryId) {
                            try { localStorage.setItem('industryId', savedIndustryId); } catch {}
                            try { localStorage.setItem('selectedIndustryId', savedIndustryId); } catch {}
                            console.log("Industry ID preserved from previous value:", savedIndustryId);
                        }
                    } catch (e) {
                        // If this fails, user is still logged in; dashboard may still work depending on endpoints.
                        console.warn("Failed to fetch/set company after auto-login:", e);
                        // Restore industry data even if company fetch failed
                        const savedIndustryId = localStorage.getItem('industryId') || localStorage.getItem('selectedIndustryId');
                        if (savedIndustryId) {
                            try { localStorage.setItem('selectedIndustryId', savedIndustryId); } catch {}
                        }
                    }

                    // Clear stored credentials (we only needed them for one-time auto-login)
                    try {
                        localStorage.removeItem("userPassword");
                        localStorage.removeItem("userEmail");
                        localStorage.removeItem("userNIN");
                    } catch {}

                    // console.log("User auto-logged in after payment");
                    // if (redirectToDashboard) {
                    //     navigate("/dashboard", { replace: true });
                    // }
                } else {
                    console.warn("Login response missing token or user data");
                }
            } else {
                console.warn("Auto-login failed:", response.data?.message);
            }
        } catch (error) {
            console.error("Error during auto-login:", error);
        }
    };

    const handleShowFunction = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };




    const handlePaystackClick = async (e) => {
        e.preventDefault();

        if (paymentMethod === "wallet") {
            // Handle wallet payment
            const amountToPay = parseFloat(planAmount.replace(/[^0-9.-]+/g, ''));
            if (isNaN(amountToPay)) {
                Swal.fire("Error", "Invalid plan amount.", "error");
                return;
            }

            if (walletBalance < amountToPay) {
                Swal.fire("Insufficient Balance", "Your wallet balance is not enough to complete this payment.", "error");
                return;
            }

            // Deduct from wallet
            const newBalance = walletBalance - amountToPay;
            setWalletBalance(newBalance);
            localStorage.setItem("walletBalance", newBalance.toString());

            // Set success summary
            const summary = {
                plan: selectedPlan?.name || planName,
                amountPaid: planAmount,
                billing: "Monthly",
            };
            setSuccessSummary(summary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
            return;
        }

        // Ensure Paystack is selected as the payment method
        if (paymentMethod !== "paystack") {
            Swal.fire("Payment Method", "Please select 'Pay with Paystack' to continue.", "warning");
            return;
        }

        // Try multiple token sources: authToken, token, or from location state
        const token = 
            localStorage.getItem("authToken") || 
            localStorage.getItem("token") ||
            location.state?.token;
        
        if (!token) {
            console.error("Authentication token not found. Available localStorage keys:", Object.keys(localStorage));
            Swal.fire("Not Logged In", "You must be logged in to make a payment. Please complete company registration first.", "error");
            return;
        }
        
        console.log("Using token for payment authentication");

        // Show processing modal immediately
        setShowPaystackModal(true);
        const startTime = Date.now();

        try {
            const payload = {
                plan_id: selectedPlan?.id,
                plan_name: selectedPlan?.name,
            };

            const res = await api.post(`/v1/pay-package`, payload);

            const data = res?.data || {};
            const isSuccess = data?.status === true || data?.success === true;
            const backendMessage =
                (typeof data?.message === "string" && data.message) ||
                (typeof data?.msg === "string" && data.msg) ||
                "";
            const checkoutUrl = typeof data?.data === "string" ? data.data : "";

            const minProcessingTime = 2000; // 2s
            const elapsed = Date.now() - startTime;
            if (elapsed < minProcessingTime) {
                await new Promise((resolve) => setTimeout(resolve, minProcessingTime - elapsed));
            }

            if (isSuccess) {
                if (!checkoutUrl) {
                    setShowPaystackModal(false);
                    await Swal.fire(
                        "Payment Initialization Failed",
                        backendMessage || "No checkout link was returned. Please try again.",
                        "error"
                    );
                    return;
                }

                // Persist summary so we can show it after Paystack redirects back.
                try {
                    localStorage.setItem(
                        "pendingPaymentSummary",
                        JSON.stringify({
                            plan: selectedPlan?.name || planName,
                            amountPaid: planAmount,
                            billing: "Monthly",
                        })
                    );
                } catch {
                    // ignore
                }

                // Redirect user to Paystack checkout.
                window.location.assign(checkoutUrl);
            } else {
                setShowPaystackModal(false);
                await Swal.fire(
                    "Payment Failed",
                    backendMessage || "Payment could not be completed. Please try again.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error initiating Paystack package payment:", error);
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.msg ||
                error?.message ||
                "Failed to initiate payment. Please try again.";
            await Swal.fire("Error", errMsg, "error");
        } finally {
            // Ensure processing modal is closed in case of early failures
            setShowPaystackModal(false);
        }
    };

    return (
        <div>
            <div className={classes.vitchri}>
                <div>
                    <img src={promix} />
                </div>

                <div className={classes.busy}>
                    <p className={classes.gate}>Features</p>
                    <p className={classes.gate}>Pricing</p>
                    <p className={classes.gate}>Resources</p>

                    <button className={classes.bu_tton}>Start Free Trial</button>
                </div>
            </div>

            <div className={classes.pirates}>
            Complete Your Purchase
            </div>

            <p className={classes.ship}>You’re one step away from getting started </p>

            <div className={classes.medor}>
                <div className={classes.mentorship2}>
                    <div className={classes.popular}>
                        <img src={star} />
                        <p>Most Popular</p>
                    </div>
                    <p className={classes.patriot}>{planName}</p>
                    <div className={classes.members}>
                        <p className={classes.organ}>{planAmount}</p>
                        <p className={classes.decept}>/month</p>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                    <Link to="/pricing-new">  <button className={classes.btnplanchnge}>
                        <img src={arrowleft} style={{width: "16px", height: '16px'}} />
                        Change Plan
                    </button>
                     </Link>
                    </div>
                    
                    <p className={classes.mogurn}>{planDescription}</p>

                    <div className={classes.mention}>
                        <div className={classes.condurn}>
                            {planPrivileges.map((privilege, index) => (
                                <div
                                    key={index}
                                    className={index === 0 ? classes.manga2 : classes.manga}
                                >
                                    <img src={marked} style={{ width: "24px", height: "24px" }} />
                                    <p className={classes.peter}>{privilege}</p>
                                </div>
                            ))}

                           <div style={{marginTop: '20px'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between', borderTop: '1px solid black', borderBottom: '1px solid black'}}>
                                <p>Subtotal</p>
                                <p>{planAmount}</p>
                            </div>
                            <div style={{display: 'flex', justifyContent: 'space-between', }}>
                                <p style={{fontSize: '18px', fontWeight: '600'}}>Total</p>
                                <p style={{fontSize: '20px', fontWeight: '600'}}>{planAmount}</p>
                            </div>
                           </div>
                        </div>
                    </div>

                </div>



                <div className={classes.mentorship}>
                    <div>
                        <div className={classes.contact_information_vid}>
                            <p className={classes.contact_information}>Contact Information</p>
                            <div className={classes.email_addressvid}>
                                <label className={classes.email_addresslabel}>Email Address</label>
                                <input type="text" placeholder='you@example.com' className={classes.email_addressinput} />
                            </div>
                        </div>

                        <div className={classes.contact_information_vid}>
                            <p className={classes.contact_information}>Personal Information</p>
                            <div className={classes.personal_information_vid}>
                                <div className={classes.email_addressvid} style={{ width: "48.5%" }}>
                                    <label className={classes.email_addresslabel}>First Name</label>
                                    <input type="text" placeholder='John' className={classes.email_addressinput} />
                                </div>
                                <div className={classes.email_addressvid} style={{ width: "48.5%" }}>
                                    <label className={classes.email_addresslabel}>Last Name</label>
                                    <input type="text" placeholder='Doe' className={classes.email_addressinput} />
                                </div>
                            </div>

                            <div className={classes.email_addressvid}>
                                <label className={classes.email_addresslabel}>Phone Number</label>
                                <input type="number" placeholder='+2348012345678' className={classes.email_addressinput} />
                            </div>
                        </div>

                        <div className={classes.contact_information_vid}>
                            <p className={classes.contact_information}>Company Name (Optional)</p>
                            <div className={classes.email_addressvid}>
                                <label className={classes.email_addresslabel}>Company Name</label>
                                <input type="text" placeholder='Company name Ltd' className={classes.email_addressinput} />
                            </div>
                        </div>

                        <div className={classes.contact_information_vid}>
                            <p className={classes.contact_information}>Payment Method</p>
                            <div className={classes.paymentmthod}>
                                <input
                                    type='radio'
                                    name="payment_method"
                                    value="wallet"
                                    checked={paymentMethod === "wallet"}
                                    onChange={() => {
                                        setPaymentMethod("wallet");
                                    }}
                                />
                               <img src={wallet}  style={{width: '24px', height: '24px'}} />
                               <div style={{flex: 1}}>
                                <p className={classes.wallttxt}>Pay with Wallet</p>
                                <p className={classes.wallttxtt}>Balance: ₦{walletBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                {paymentMethod === "wallet" && walletBalance < parseFloat(planAmount.replace(/[^0-9.-]+/g, '')) && (
                                    <p style={{color: '#ef4444', fontSize: '12px', marginTop: '4px'}}>You do not have sufficient funds in wallet</p>
                                )}
                               </div>
                               {paymentMethod === "wallet" && walletBalance < parseFloat(planAmount.replace(/[^0-9.-]+/g, '')) && (
                                <button 
                                    className={classes.fundWalletBtn}
                                    onClick={() => setShowAccountDetailsModal(true)}
                                    style={{
                                        backgroundColor: '#10b981',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                        fontWeight: '600'
                                    }}
                                >
                                    Fund Wallet
                                </button>
                               )}
                            </div>
                            <div className={classes.paymentmthod2}>
                                <input
                                    type='radio'
                                    name="payment_method"
                                    value="paystack"
                                    checked={paymentMethod === "paystack"}
                                    onChange={() => {
                                        setPaymentMethod("paystack");
                                        setShowAccountDetailsModal(false);
                                    }}
                                />
                               <img src={card}  style={{width: '24px', height: '24px'}} />
                               <div>
                                <p className={classes.wallttxt}>Pay with Paystack</p>
                                <p className={classes.wallttxtt}>Cards, bank transfers, USSD, and mobile money</p>
                               </div>
                            </div>
                        </div>

                        {/* <div className={classes.paystack_vid}>
                            <img src={credtcrd} style={{ width: "24px", height: "24px" }} />
                            <p className={classes.paystack_text}> You'll be redirected to Paystack's secure payment page to complete your transaction. Paystack accepts cards, bank transfers, USSD, and mobile money</p>
                        </div> */}

                        <button className={classes.negate2} onClick={handlePaystackClick}>Continue with Payment</button>
                        
                        <div style={{ textAlign: "center", gap: '50px' }}>
                            <p className={classes.paystackassure_text}> Secured by <span style={{color: "rgba(2, 132, 199, 1)", fontWeight:  "700"}}>Paystack</span> </p>
                            <div className={classes.assure} style={{marginTop: '30px'}}>
                                <img src={lock} className={classes.lock} />
                                <p className={classes.paystack_text}>  Your payment information is encrypted and secure</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {showPaystackModal && (
                <div className={classes.paystack_overlay}>
                    <div className={classes.paystack_modal}>
                        <img src={promix} className={classes.paystack_logo} />
                        <div className={classes.spinner} aria-label="Connecting to Paystack" />
                        <p className={classes.modal_title}>Redirecting to Paystack...</p>
                        <p className={classes.modal_subtitle}>Please wait while we connect you to Paystack’s secure payment page</p>

                        <button className={classes.paystack_badge}>
                            <div>
                                 <span className={classes.lock_dot}> <img src={lock} className={classes.lock2} /></span>
                            </div>
                           <div>
                             Secured by <span className={classes.paystack_name}>Paystack</span>
                           </div>
                           
                        </button>

                        <div className={classes.progress_list}>
                            <div className={classes.progress_item}>
                                <img src={marked} alt="" className={classes.progress_icon} />
                                <p className={classes.progress_text}>Details Verified</p>
                            </div>
                            <div className={classes.progress_item}>
                                <img src={marked} alt="" className={classes.progress_icon} />
                                <p className={classes.progress_text}>Connecting to payment gateway</p>
                            </div>
                            <div className={classes.progress_item_pending}>
                                <span className={classes.pending_dot} />
                                <p className={classes.progress_text_pending}>Complete Payment</p>
                            </div>
                        </div>

                        <p className={classes.modal_footer}>Do not close the window or press the back button.<br />This process usually takes a few seconds.</p>
                    </div>
                </div>
            )}



            <Modal
                show={showSuccessModal}
                // onHide={handleCloseSuccessModal}
                className={classes.customModal}
                size="md"
            >
                <Modal.Body>
                    <div className={classes.success_modal}>
                        <p className={classes.success_title}>Payment Successful !</p>
                        <p className={classes.success_subtitle}>Your payment has been completed successfully</p>

                        <div className={classes.success_badge_wrap} aria-hidden="true">
                            <div className={classes.success_badge}>
                                <span className={classes.success_check} />
                            </div>
                        </div>

                        <div className={classes.success_pill}>
                            You now have full access to the <b> {successSummary?.plan || planName} Plan</b>
                        </div>

                        <div className={classes.success_summary}>
                            <p className={classes.success_summary_title}>Transaction Summary</p>
                            <div className={classes.success_divider} />

                            <div className={classes.success_row}>
                                <span className={classes.success_label}>Plan</span>
                                <span className={classes.success_value}>{successSummary?.plan || planName}</span>
                            </div>
                            <div className={classes.success_row}>
                                <span className={classes.success_label}>Amount Paid</span>
                                <span className={classes.success_value}>{successSummary?.amountPaid || planAmount}</span>
                            </div>
                            <div className={classes.success_row}>
                                <span className={classes.success_label}>Billing</span>
                                <span className={classes.success_value}>{successSummary?.billing || "Monthly"}</span>
                            </div>

                            <div className={classes.success_divider_bottom} />
                        </div>
                        {/* <button className={classes.success_cta} onClick={() => navigate("/dashboard")}> */}
                        {/* <button className={classes.success_cta} onClick={() => setShowAcctModal(true)}> */}
                        <button
                            className={classes.success_cta}
                            onClick={() => {
                                const companyId = locationCompanyId || localStorage.getItem("company_id") || localStorage.getItem("activeCompanyId");
                                const industryId = locationIndustryId || localStorage.getItem("industryId") || localStorage.getItem("selectedIndustryId");
                                navigate("/chart-of-account", {
                                    state: {
                                        company_id: companyId,
                                        industryId: industryId,
                                        selectedPlan: selectedPlan
                                    }
                                });
                            }}
                            disabled={isRestoringSession}
                        >
                            {isRestoringSession ? "Preparing your account..." : "Continue"}
                        </button>

                        <p className={classes.success_footer}>
                            {isRestoringSession ? "Finishing account setup. Please wait before continuing." : "A receipt has been sent to your mail"}
                        </p>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                <button
                    className={classes.customCancelBtn}
                    onClick={handleCloseAcctModal}
                >
                    Cancel
                </button>
                <button
                    className={classes.customSaveBtn}
                    onClick={saveNewAccounts}
                    disabled={savingAccountsLoading}
                >
                    {savingAccountsLoading ? "Processing..." : "Continue to Dashboard"}
                </button>
                </Modal.Footer> */}
            </Modal>

            <Modal
                show={showAcctModal}
                onHide={handleCloseAcctModal}
                className={classes.customModal}
                size="lg"
            >
                <Modal.Body>
                <Modal.Header closeButton>
                    <Modal.Title><b>Chart of Account Setup</b></Modal.Title>
                </Modal.Header>
                <Form className={classes.compactForm}>
                    <table className={classes.table}>
                        <thead>
                            <tr>
                            <th>#</th>
                            <th>Account Name</th>
                            <th>Account Code/Type</th>
                            <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accountsLoading ? (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", padding: "40px" }}>
                                <div className={classes.spinnerWrapper}><div className={classes.spinner}></div></div>
                                </td>
                            </tr>
                            ) : rows.length === 0 ? (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                                No rows available.
                                </td>
                            </tr>
                            ) : (
                            rows.map((row, index) => (
                                <tr key={index}>
                                <td style={{fontSize:"13px"}} >{index + 1}</td>
                                <td>
                                    <input
                                    type="text"
                                    className={classes.debitInput}
                                    value={row.accountName}
                                    onChange={(e) => handleChange(index, "accountName", e.target.value)}
                                    placeholder="Enter Account Name"
                                    disabled={row.isPrefilled}
                                    // disabled={row.accountName && parseFloat(row.accountName) > 0}
                                    />
                                </td>
                                <td>
                                {row.isPrefilled ? (
                                <input
                                    type="text"
                                    className={classes.debitInput}
                                    value={row.accountCode}
                                    onChange={(e) => handleChange(index, "accountCode", e.target.value)}
                                    // placeholder="0.00"
                                    disabled={row.isPrefilled}
                                    />
                                ) : (
                                <select
                                    id="accountType"
                                    className={classes.formSelect}
                                    value={row.accountCode}
                                    onChange={(e) => handleChange(index, "accountCode", e.target.value)}
                                    disabled={row.isPrefilled}
                                >
                                    <option value="" disabled>{loadingTypes ? 'Loading types...' : 'Select Account type'}</option>
                                    {accountTypes.map((t, idx) => {
                                        const value = t?.id ?? t?.value ?? t?.code ?? t?.description ?? t?.label ?? `${idx}`;
                                        const label = t?.description ?? t?.label ?? t?.title ?? t?.displayName ?? String(value);
                                        return (
                                            <option key={value} value={value}>{label}</option>
                                        );
                                    })}
                                </select>
                                )}
                                </td>
                                <td>
                                    <img
                                    src={deletes}
                                    alt="Delete"
                                    onClick={() => !row.isPrefilled && removeRow(index)}
                                    style={{
                                        cursor: row.isPrefilled ? "not-allowed" : "pointer",
                                        width: "50%",
                                        opacity: row.isPrefilled ? 0.5 : 1
                                    }}
                                    />
                                    {/* <button  className={classes.removeBtn}>Remove</button> */}
                                </td>
                                </tr>
                            ))
                            )}
                        </tbody>

                    </table>
                </Form>
                <button
                    className={classes.customAddBtn}
                    onClick={addLine}
                >
                    + Add Account
                </button>
                </Modal.Body>
                <Modal.Footer>
                <button
                    className={classes.customCancelBtn}
                    onClick={handleCloseAcctModal}
                >
                    Cancel
                </button>
                <button
                    className={classes.customSaveBtn}
                    onClick={saveNewAccounts}
                    disabled={savingAccountsLoading}
                >
                    {savingAccountsLoading ? "Processing..." : "Continue to Dashboard"}
                </button>
                </Modal.Footer>
            </Modal>

            {showDeclinedModal && (
                <div className={classes.paystack_overlay}>
                    <div className={classes.declined_modal}>
                        <div className={classes.declined_badge_wrap} aria-hidden="true">
                            <div className={classes.declined_badge}>
                                <div className={classes.declined_icon} />
                            </div>
                        </div>

                        <p className={classes.declined_title}>Payment Not Completed</p>
                        <p className={classes.declined_subtitle}>
                            No charges were made to your account<br />
                            You can try again or choose a different payment method
                        </p>

                        <div className={classes.declined_actions}>
                            <button
                                className={classes.declined_primary}
                                onClick={() => {
                                    setShowDeclinedModal(false);
                                    setPaymentMethod("");
                                }}
                            >
                                Change payment method
                            </button>
                            <button
                                className={classes.declined_secondary}
                                onClick={() => {
                                    setShowDeclinedModal(false);
                                    // Remove query params so the user can retry cleanly.
                                    navigate(location.pathname, { replace: true });
                                }}
                            >
                                Try Again
                            </button>
                        </div>

                        <p className={classes.declined_footer}>
                            If you were debited, please contact our support team for assistance<br />
                            <span
                                className={classes.declined_support_link}
                                onClick={() => window.open("mailto:support@promix.com", "_blank")}
                            >
                            Contact Support
                            </span>
                        </p>
                    </div>
                </div>
            )}

            {showAccountDetailsModal && (
                <div className={classes.paystack_overlay}>
                    <div className={classes.success_modal} style={{maxWidth: '400px'}}>
                        <p className={classes.success_title}>Account Details</p>
                        <p className={classes.success_subtitle}>Use these details to fund your wallet via bank transfer</p>

                        <div style={{border: '1px solid #ddd', padding: '15px', borderRadius: '5px', backgroundColor: '#f9f9f9', margin: '20px 0'}}>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Account Name:</strong> {accountDetails.accountName}</p>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Account Number:</strong> {accountDetails.accountNumber}</p>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Bank:</strong> {accountDetails.bank}</p>
                        </div>

                        <div style={{margin: '20px 0px 0px 0px ', textAlign: 'center'}}>
                            <p style={{fontSize: '14px'}}>I have funded wallet</p>
                        </div>

                        <button className={classes.declined_primary} onClick={() => setShowAccountDetailsModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            <p className={classes.proeterw}>Trusted by 10,000+ businesses worldwide</p>
            <div className={classes.pitfall}>
                <div className={classes.number_num}>
                    <p className={classes.costat}>₦50B+</p>
                    <p className={classes.prethelr}>Processed Monthly</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>99.9%</p>
                    <p className={classes.prethelr}> Uptime SLA</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>500+</p>
                    <p className={classes.prethelr}>Integrations</p>
                </div>
            </div>
        </div>

    )
}

export default PricingNewPayment;
